import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseTransferJobQueueView } from "src/components/views/erp/warehouse/transfer/WarehouseTransferJobQueueView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/transferJobQueue")({
	staticData: { title: i18n.t("warehouse_job_queue"), legacyViewKey: "warehouseTransferJobQueueView" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <WarehouseTransferJobQueueView isActive={isActive} />;
}
